import { api } from "@/services/api";

export interface TestTypeRequest {
  testName: string;
  testDescription: string;
  testCategory: string;
  status: "ACTIVE" | "INACTIVE";
  testComponents?: string; // JSON array string
}

export interface TestType extends TestTypeRequest {
  id: number;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export const testApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // List all tests
    listTests: builder.query<TestType[], void>({
      query: () => "/super-admin/tests",
      providesTags: ["Tests"],
    }),

    // Get active tests
    listActiveTests: builder.query<TestType[], void>({
      query: () => "/super-admin/tests/active",
      providesTags: ["Tests"],
    }),

    // Create test
    createTest: builder.mutation<TestType, TestTypeRequest>({
      query: (body) => ({
        url: "/super-admin/tests",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Tests"],
    }),

    // Update test
    updateTest: builder.mutation<TestType, { id: number; data: TestTypeRequest }>({
      query: ({ id, data }) => ({
        url: `/super-admin/tests/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Tests"],
    }),

    // Get test by ID
    getTestById: builder.query<TestType, number>({
      query: (id) => `/super-admin/tests/${id}`,
      providesTags: ["Tests"],
    }),

    // Delete test
    deleteTest: builder.mutation<void, number>({
      query: (id) => ({
        url: `/super-admin/tests/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tests"],
    }),
  }),
});

export const {
  useListTestsQuery,
  useListActiveTestsQuery,
  useCreateTestMutation,
  useUpdateTestMutation,
  useGetTestByIdQuery,
  useDeleteTestMutation,
} = testApi;
